// @ts-ignore
import { Caas } from "caas_sdk_web";
import { getMudrexOffRampWidgetKeys} from '../../services/backendHelpers';
import { useLocation, useNavigate } from "react-router-dom";
import { eventTracker } from "../../services/eventTracker";
import React, { useEffect, useState } from "react";

const OffRampPage = (props: any) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    
    const address = searchParams.get("address");
    const email = searchParams.get("email");
    
    const navigate: any = useNavigate();
    
    const  init  =  async () => {
	let resp:any = await getMudrexOffRampWidgetKeys();
        let data = resp.data;
        console.log('222', data)
        return data;
    };
    
    console.log('legend22');
    
    return  (
        <div style={{
            display:'flex',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
          <Caas
              init={init}
              onSuccess={() => {
                  console.log("Success");
              }}
              sdkConfiguration={{ steps: ["kyc"], kycEnabled: true }}
              onKYCSuccessCallback={() => {
                  eventTracker('offramp_kyc_done', {});
                  navigate(`/wallet-host/mudrex-off-ramp-main/`);
              }}
              offRampSuccessCallback={() => {}}
          />
        </div>
    )
}

export default OffRampPage;

